import {
  GqlShareIssue,
  GqlShareIssueParticipant,
  GqlShareIssueRegistration,
} from '../../../../graphql/base-types.graphql';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';
import { ParticipantsTable } from '../ParticipantsTable';
import { DisplayIdentity } from '@startuptools/business-ui/identity/Identity';
import { Alert } from '@startuptools/ui/Alert';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { useStepper } from '../../../../components/steppers/common/StepperContext';
import { useStepperStepContent } from '../../../../components/steppers/common/StepperStepContentContext';
import { ErrorDisplay } from '../../../../components/error-display/ErrorDisplay';
import { PaymentKind } from '@startuptools/common/participants';

export const SiStepParticipants = ({
  shareIssue,
  shareIssueRegistration,
}: {
  shareIssue: Pick<
    GqlShareIssue,
    'id' | 'pricePerShare' | 'currency' | 'companyId' | 'shareClasses' | 'paymentKindCash'
  >;
  shareIssueRegistration: Pick<GqlShareIssueRegistration, 'id'> & {
    participants: (Pick<
      GqlShareIssueParticipant,
      'id' | 'paymentStatus' | 'numberOfShares' | 'shareClass' | 'paymentKind'
    > & {
      identity: DisplayIdentity;
    })[];
  };
}) => {
  const { stepNext } = useStepper();
  const { validatorStatus } = useStepperStepContent();

  const sips = shareIssueRegistration.participants;

  return (
    <Stack gap={3}>
      <Typography level="h4">
        <Trans id="Who is subscribing for shares" />
      </Typography>

      <Alert>
        <Trans id="Here you input the investors who are participating in the share issue and how much they will invest." />
      </Alert>

      <ParticipantsTable
        shareIssue={shareIssue}
        sips={sips}
        paymentKind={PaymentKind.Cash}
        sirId={shareIssueRegistration.id}
      />

      {validatorStatus?.hasError && <ErrorDisplay error={validatorStatus.error} />}

      <Box>
        <Button onClick={() => stepNext()}>
          <Trans id="Continue" />
        </Button>
      </Box>
    </Stack>
  );
};
